<fgb-facial-recognition-stepper [(counter)]="stepCounter">
  <fgb-facial-recognition-step>
    <div step-content>
      <fgb-facial-recognition-take-photo
        [uploadedImage]="uploadedImage"
        [formData]="formData"
        [stepCounter]="stepCounter"
        (nextStepChange)="nextStep()"
        (previousStepChange)="prevStep()"
      ></fgb-facial-recognition-take-photo>
    </div>
  </fgb-facial-recognition-step>
  <fgb-facial-recognition-step>
    <div step-content>
      <fgb-facial-recognition-review-photo
        [uploadedImage]="uploadedImage"
        [formData]="formData"
        [stepCounter]="stepCounter"
        [(isUploadInfo)]="isUploadInfo"
        (goToStepChange)="setStep($event)"
        (validatePhoto)="validatePhoto()"
        (setStep)="setStep($event)"
        (nextStepChange)="nextStep()"
        (previousStepChange)="prevStep()"
      ></fgb-facial-recognition-review-photo>
    </div>
  </fgb-facial-recognition-step>
  <fgb-facial-recognition-step>
    <div step-content>
      <fgb-facial-recognition-validating-photo
        #validatingPhoto
        [formData]="formData"
        [stepCounter]="stepCounter"
        (setStep)="setStep($event)"
        (previousStepChange)="prevStep()"
      ></fgb-facial-recognition-validating-photo>
    </div>
  </fgb-facial-recognition-step>
  <fgb-facial-recognition-step>
    <div step-content>
      <fgb-facial-recognition-review-photo-failed
        [uploadedImage]="uploadedImage"
        [formData]="formData"
        [stepCounter]="stepCounter"
        [(isUploadInfo)]="isUploadInfo"
        (setStep)="setStep($event)"
        (previousStepChange)="prevStep()"
      ></fgb-facial-recognition-review-photo-failed>
    </div>
  </fgb-facial-recognition-step>
  <fgb-facial-recognition-step>
    <div step-content>
      <fgb-facial-recognition-photo-success
        [uploadedImage]="uploadedImage"
        [stepCounter]="stepCounter"
        (setStep)="setStep($event)"
        (previousStepChange)="prevStep()"
      ></fgb-facial-recognition-photo-success>
    </div>
  </fgb-facial-recognition-step>
</fgb-facial-recognition-stepper>
